import { formatDate } from '@helpers/DateHelper'

export default (date, format = 'date_time', defaultValue) =>
  formatDate(date, { format, defaultValue, timeZone: 'userTimeZone' })
